import React from 'react'

import Space from '../../../components/SpaceContent'

import What from './What'
import Where from './Where'
import When from './When'


const Workspace = ({ page }) => {
    return (
        <>
            <Space>
                <What />
                <Where />
                <When/>
            </Space>
        </>
    )
}

export default Workspace